
<template>
  <div class="insight">
    <div class="insight-banner">
      <img :src="bannerimg" />
      <div class="insight-banner-text">
        <div class="insight-banner-title">
          “一切智慧，都发端于对事实的认识。”
        </div>
        <div class="insight-banner-author">
          —— 芬兰前总统 尤霍·库斯蒂·巴锡基维
        </div>
        <div class="insight-banner-content">
                  在数字化转型不断加速的今天，企业需要提升洞察力以应对风险。凭借洞察力，企业能够预测潜在威胁，识别重大机会，迅速定位自己，在竞争对手之前采取行动，从而减小风险，抓住机遇。
                  
          专业的洞察离不开专业的方法，科学的流程、方法和工具不仅能带来深入的洞见，也能给客户更好的感知。为了让每个部门、每个角色都能快速开展专业有效的用户洞察，收获科学结果，金蝶用户体验部制作了《客户全旅程调研操作手册》。手册详细描述了不同阶段、不同角色所能进行的洞察研究，确保人人都能对客户体验进行有效诊断，帮助各旅程阶段的触点经营部门提升洞察力和客户体验经营能力。
        </div>
      </div>
    </div>
    <insight-filter @filterData="filterData"></insight-filter>
    <div class="insight-cards" v-if="cardsFilterData.length >= 1 ">
      <InsightCard 
        class=""
        v-for="(item, index) in cardsFilterData"
        :key="item.id"
        :cardInfor="item"
        :style="{ marginRight: index % 3 === 2 ? '0' : '35px' }"
      />
    </div>
      <div v-else class="insight-nocontent">
         <img :src="ErrorImg"/>
         <div>无相关研究主题，请重新筛选～</div>
      </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import BannerImg from "@/assets/img/insight/banner.png";
import ErrorImg from "@/assets/img/insight/error.png";
import InsightFilter from "@/components/insight/Filter";
import InsightCard from "@/components/insight/InsightCard";
import {cardsData} from "@/assets/js/cards";
export default {
  name: "Base",
  data() {
    return {
      bannerimg: BannerImg,
      ErrorImg,
      cardsData,
      cardsFilterData: cardsData
    }
  },
  components: {
    InsightFilter,
    InsightCard,
  },
  computed: {},
  created() {
    this.getInsightList(this.cardsData.map(c => c._id).filter(f => !!f))
  },
  methods: {
    ...mapActions('insight', ['getInsightList']),
    filterData: function (f) {
      this.cardsFilterData = Object.assign([],this.cardsData.filter((card) => {
       
         let isSearch = f[0]!=='不限' ? card.search && card.search.indexOf(f[0]) > -1 : true
         let isPosition = f[1]!=='不限' ? card.position && card.position.indexOf(f[1]) > -1  : true
         let isJourney = f[2]!=='不限' ? card.journey && card.journey.indexOf(f[2]) > -1 : true
         let isIPD = f[3]!=='不限' ? card.IPD && card.IPD.indexOf(f[3]) > -1 : true
        return isSearch &&  isPosition && isJourney && isIPD
      }))
      console.log(this.cardsFilterData)
    },
  },
};
</script>
<style lang="scss">
.insight {
  > .insight-banner {
    background: rgba(248, 248, 248, 1);
    border-radius: 6px;
    padding: 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 28px;
    > img {
      height: 248px;
    }
    > .insight-banner-text {
      padding-left: 28px;
      .insight-banner-title {
        font-size: 28px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 700;
      }
      .insight-banner-author {
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        text-align: justify;
        line-height: 19px;
        font-weight: 700;
        text-align: right;
        margin: 14px 0;
      }
      .insight-banner-content {
        font-size: 13px;
        color: #999999;
        letter-spacing: -0.4px;
        text-align: justify;
        line-height: 24px;
        font-weight: 400;
      }
    }
  }
  > .insight-cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 40px;
    >div {
        margin-bottom: 35px;
    }
  }
  >.insight-nocontent {
        display: flex;
    justify-content: left;
    flex-direction: column;
    align-items: center;
    margin: 100px 0;
    font-size: 16px;
  color: #666666;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
    >img {
      width: 184px;
    }
  }
}
</style>